import { useEffect, useState } from 'preact/hooks';

export default function ErrorMessage({ children, id, showErrors }) {
	const [aria, setAria] = useState('assertive');

	useEffect(() => {
		let timeout;
		if (showErrors) {
			timeout = setTimeout(() => {
				setAria('polite');
			}, [1000]);
		}
		return () => clearTimeout(timeout);
	}, [showErrors]);

	return (
		<div
			class="alert alert-danger"
			id={id}
			aria-live={aria}
		>
			{showErrors && children}
		</div>
	);
}
